import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { AreaEntity } from 'src/modules/dashboard/dto/area/area.entity';
import { ResponseDocument } from 'src/modules/dashboard/dto/response';

interface AreaState {
  areaCoordinates: string;
  selectedArea?: ResponseDocument<AreaEntity>;
  isAllAreasSelected: boolean;
  selectedRiverNames: string[];
  selectedRiverBounds?: [[number, number], [number, number]];
}

const initialState: AreaState = {
  areaCoordinates: '',
  selectedArea: undefined,
  isAllAreasSelected: false,
  selectedRiverNames: [],
  selectedRiverBounds: undefined,
};

export const areaSlice = createSlice({
  name: 'areaSlice',
  initialState,
  reducers: {
    setSelectedArea: (state, action: PayloadAction<Partial<AreaState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setSelectedArea } = areaSlice.actions;

// Selectors
export const selectAreaCoordinates = (state: { areaReducer: AreaState }) => state.areaReducer.areaCoordinates;
export const selectSelectedArea = (state: { areaReducer: AreaState }) => state.areaReducer.selectedArea;
export const selectIsAllAreasSelected = (state: { areaReducer: AreaState }) =>
  state.areaReducer.isAllAreasSelected;
export const selectSelectedRiverNames = (state: { areaReducer: AreaState }) => state.areaReducer.selectedRiverNames;
export const selectSelectedRiverBounds = (state: { areaReducer: AreaState }) => state.areaReducer.selectedRiverBounds;

export const areaReducer = areaSlice.reducer;
